<template>
  <div>
    <el-button type="primary" class="addBtn" @click="addBtnClick">添加友情链接</el-button>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="sort"
		      label="权重"
		      align="center"
		      width="80"
        >
		    </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="url"
          label="跳转链接"
          align="center"
        >
        </el-table-column>
		    <el-table-column
		      label="操作"
		      align="center"
		      width="150"
        >
         <template slot-scope="scope">
         	  <div class="operation-wrap">
         	    <span class="opration-item" @click="editLinkClick(scope.row)">编辑</span>
               <span class="opration-item" @click="deleteLinkClick(scope.row)">删除</span>
         	  </div>
         </template>
		    </el-table-column>
		  </el-table>
      <common-pagination
			  :total="total"
        :page_size="page_size"
			  @size-change="handelPagesizeChange"
			  @page-change="handlePageChange"
			></common-pagination>
    </div>
    <common-dialog
      :title="dialogTitle"
      :dialogVisible="dialogVisible"
      @cancel="dialogVisible = false"
      @confirm="dialogConfirmClick"
      @dialog-close="dialogClose"
		>
      <div class="dialog-body-wrap">
  		  <div v-if="dialogType === 'delete'">
          是否删除友情链接？
        </div>
        <div v-if="dialogType === 'add' || dialogType ==='edit'" class="input-wrap-container">
  		  	<div class="input-wrap">
  		  		<label>链接名称</label>
  		  		<el-input v-model="handle_row.name" placeholder="请输入链接名称"></el-input>
  		  	</div>
          <div class="input-wrap">
  		  		<label>链接地址</label>
  		  		<el-input v-model="handle_row.url" placeholder="请输入链接地址"></el-input>
  		  	</div>
  		  	<div class="input-wrap">
  		  		<label>权重</label>
  		  		<el-input v-model="handle_row.sort" placeholder="请输入权重"></el-input>
  		  	</div>
  		  </div>
      </div>
		</common-dialog>
  </div>
</template>

<script>
import { getLinkList, addLinkList, editLinkList, deleteLinkList } from '@/api/friendly-link';
import { mapState } from 'vuex';
import CommonDialog from '@/components/CommonDialog';
import CommonPagination from '@/components/CommonPagination';

export default {
  name: 'slideimgmanage',
  data() {
  	return {
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      dialogType: '',
      handle_row: {},
      page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
  	}
  },
  computed: {
  	...mapState(['imgDomain'])
  },
  mounted() {
    this._getLinkList();
  },
  components: {
    CommonDialog,
    CommonPagination
  },
  methods: {
    addBtnClick() {
      this.dialogType = 'add';
      this.dialogTitle = '新增友情链接';
      this.dialogVisible = true;
    },
  	async _getLinkList() {
      let postData = {
        page_index: this.page_index,
        page_size: this.page_size
      }
  		const { data, status } = await getLinkList(postData);
      console.log(data, '友情链接')
      if (status !== 200) return
  		this.tableData = data.data.data;
  	},
  	dialogClose() {
      this.getCarouselList();
  	},
  	editLinkClick(row) {
      this.handle_row = JSON.parse(JSON.stringify(row));
      this.dialogType = 'edit';
      this.dialogTitle = '编辑友情链接';
      this.dialogVisible = true;
    },
    deleteLinkClick(row) {
      this.handle_row = JSON.parse(JSON.stringify(row));
      this.dialogType = 'delete';
      this.dialogTitle = '提示';
      this.dialogVisible = true;
    },
    async dialogConfirmClick() {
      let dialogType = this.dialogType;
      if (dialogType === 'edit' || dialogType === 'add') {
        const { sort, name, url } = this.handle_row;
        if (!name) {
          this.$message('链接名称不能为空');
          return
        }
        if (!url) {
          this.$message('链接地址不能为空');
          return
        }
        if (!sort) {
          this.$message('权重不能为空');
          return
        }
        if (+sort < 0 || +sort > 99 || sort%1 !== 0) {
          this.$message('权重必须为0～99之间的整数');
          return
        }
        if (dialogType === 'add') {
          const { status } = await addLinkList(this.handle_row);
          if ( status === 200 ) this.dialogVisible = false
        } else if (dialogType === 'edit') {
          const { status } = await editLinkList(this.handle_row);
          if ( status === 200 ) this.dialogVisible = false
        }
      } else if (dialogType === 'delete') {
        const { status } = await deleteLinkList(this.handle_row.id);
        if ( status === 200 ) this.dialogVisible = false
      }
  	},
  	dialogClose() {
      this.dialogVisible = false;
      this.handle_row = {};
      this._getLinkList()
    },
    handelPagesizeChange(size) {
      this.page_size = size;
      this._getLinkList()
  	},
  	handlePageChange(page) {
      this.page_index = page;
      this._getLinkList();
  	},
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.addBtn {
	float: right;
	margin-bottom: 30px;
}
.table-wrap {
  margin-bottom: 40px;
  .carousel-img {
    max-width: 400px;
    max-height: 300px;
  }
}
.operation-wrap {
	display: flex;
	justify-content: space-around;
	color: @color-text;
	.opration-item{
		cursor: pointer;
	}
}
.dialog-body-wrap {
	text-align: center;
	.input-wrap-container {
		text-align: left;
		.input-wrap {
			margin-bottom: 30px;
		}
	}
}
</style>
